import type { Client, ClientHeaders } from "@medusajs/js-sdk";

import type { SalonStockerHttpTypes } from "../types";

/**
 * Client for the concierge login link (`/enter`).
 *
 * The one pre-auth store surface: redemption exists to create the session the
 * salon does not have yet, so it deliberately takes no authorization header.
 */
export class Concierge {
  /**
   * @ignore
   */
  private client: Client;

  /**
   * @ignore
   */
  constructor(client: Client) {
    this.client = client;
  }

  /**
   * Exchange a concierge token for a customer JWT.
   *
   * A **POST**, not a GET on the link itself: WhatsApp fetches a shared URL to
   * build its preview card before the recipient ever taps it, and crawlers do
   * not run JS - so redeeming on page load would burn the link before first
   * use. The link stays redeemable for its whole window, so reopening the
   * message keeps working.
   *
   * Rejects with a 401 `FetchError` when the link is unknown, expired or has
   * been replaced by a newer one; the message is salon-facing copy.
   */
  redeem = async (
    token: string,
    headers?: ClientHeaders
  ): Promise<SalonStockerHttpTypes.ConciergeLinkRedeemResponse> =>
    this.client.fetch<SalonStockerHttpTypes.ConciergeLinkRedeemResponse>(
      "/store/concierge/links/redeem",
      {
        method: "POST",
        body: {
          token
        } satisfies SalonStockerHttpTypes.ConciergeLinkRedeemRequest,
        headers
      }
    );
}
